import { render } from "./CompanySwitcher.vue?vue&type=template&id=15611cb7"
import script from "./CompanySwitcher.vue?vue&type=script&lang=js"
export * from "./CompanySwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/CompanySwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15611cb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15611cb7', __exports__)) {
    api.reload('15611cb7', __exports__)
  }
  
  module.hot.accept("./CompanySwitcher.vue?vue&type=template&id=15611cb7", () => {
    api.rerender('15611cb7', render)
  })

}


export default __exports__